import API from './API'
import Record_behavir from './FirebaseAPI/RecordBill'
import Cookies from 'js-cookie'

var record = new Record_behavir()

const Customer = (function () {
  function customer() {}

  // 錯誤訊息轉換表
  const errorMessageMap = {
    '請輸入數字型態的 contactPhone 值': '請檢查聯絡電話是否為純數字！',
    '請輸入數字型態的 phone 值': '請檢查來電電話是否為純數字！',
  }

  // 錯誤訊息轉換方法
  customer.prototype.translateErrorMessage = function (errorMessage) {
    return errorMessageMap[errorMessage] || errorMessage
  }

  customer.prototype.getCustomerList = function (npp, page, keyword) {
    return API.get(`customer/list/?npp=${npp}&page=${page}&kw=${keyword}`)
  }
  customer.prototype.getCustomerInfo = function (phone, customerId) {
    let url = ''
    if (phone !== undefined) {
      url = `customer/v2/?phone=${phone}`
    }
    if (customerId !== undefined) {
      url = `customer/v2/?id=${customerId}`
    }
    return API.get(url)
  }
  customer.prototype.createCustomerInfo = function (customerInfo) {
    return API.post('customer/webadd', customerInfo)
  }
  customer.prototype.createCustomer = async function (
    customerInfo,
    isFormPhoneHail = false,
  ) {
    // 新增乘客資料時，需要傳入 isFormPhoneHail 參數，用來判斷是否是從派車頁面新增
    const infoWithFlag = Object.assign({}, customerInfo, {
      isFormPhoneHail: isFormPhoneHail,
    })
    return await API.post('customer/v2', customerInfo)
      .then((data) => {
        if (!data.success) throw new RangeError(data.error)
        let recordInfo = {}
        recordInfo.id = data.result.id
        recordInfo.type = '乘客資料'
        recordInfo.event = '新增乘客資料'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.note = JSON.stringify(infoWithFlag)
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data.message,
          result: { id: recordInfo.id },
        }
      })
      .catch((err) => {
        console.log(err)
        const errorMessage =
          err.response &&
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.message
            ? err.response.data.error.message
            : '新增失敗'
        return {
          success: false,
          message: this.translateErrorMessage(errorMessage),
        }
      })
  }
  customer.prototype.updateCustomer = async function (
    customerInfo,
    isFormPhoneHail = false,
  ) {
    const infoWithFlag = Object.assign({}, customerInfo, {
      isFormPhoneHail: isFormPhoneHail,
    })
    return await API.post('customer/v2', customerInfo)
      .then((data) => {
        if (!data.success) throw new RangeError(data.error)
        let recordInfo = {}
        recordInfo.id = data.result.target
        recordInfo.type = '乘客資料'
        recordInfo.event = '修改乘客資料'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.note = JSON.stringify(infoWithFlag)
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data.message,
          result: { id: recordInfo.id },
        }
      })
      .catch((err) => {
        console.log(err)
        const errorMessage =
          err.response &&
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.message
            ? err.response.data.error.message
            : '編輯失敗'
        return {
          success: false,
          message: this.translateErrorMessage(errorMessage),
        }
      })
  }
  customer.prototype.createCustomerBlackList = async (customerInfo) => {
    try {
      const data = await API.post('customer/black_driver', customerInfo)
      if (!data.success) {
        throw new Error(data.error || '新增黑名單失敗')
      }

      const recordInfo = {
        type: '乘客資料',
        event: '新增黑名單',
        code: Cookies.get('GladTeamCode'),
        id: customerInfo.customerId,
        note: JSON.stringify(customerInfo),
        user_name: Cookies.get('GladName'),
        user_id: '',
      }

      await record.postRecord(recordInfo)

      return {
        success: true,
        message: data.message,
      }
    } catch (err) {
      console.error('新增黑名單錯誤:', err)
      let errorMessage = '新增黑名單失敗'
      if (
        err.response &&
        err.response.data &&
        err.response.data.error &&
        err.response.data.error.message
      ) {
        errorMessage = err.response.data.error.message
      }
      return {
        success: false,
        message: errorMessage,
      }
    }
  }

  customer.prototype.updateCustomerBlackList = async (customerInfo) => {
    try {
      const data = await API.put('customer/black_driver', customerInfo)
      if (!data.success) {
        throw new Error(data.error || '編輯黑名單失敗')
      }

      const recordInfo = {
        type: '乘客資料',
        event: '編輯黑名單',
        code: Cookies.get('GladTeamCode'),
        id: customerInfo.customerId,
        note: JSON.stringify(customerInfo),
        user_name: Cookies.get('GladName'),
        user_id: '',
      }

      await record.postRecord(recordInfo)

      return {
        success: true,
        message: data.message,
      }
    } catch (err) {
      console.error('編輯黑名單錯誤:', err)
      let errorMessage = '編輯黑名單失敗'
      if (
        err.response &&
        err.response.data &&
        err.response.data.error &&
        err.response.data.error.message
      ) {
        errorMessage = err.response.data.error.message
      }
      return {
        success: false,
        message: errorMessage,
      }
    }
  }

  customer.prototype.removeCustomerBlackList = async (customerInfo) => {
    return await API.delete('customer/black_driver', { data: customerInfo })
      .then((data) => {
        if (!data.success) throw new RangeError(data.error)
        let recordInfo = {}
        recordInfo.type = '乘客資料'
        recordInfo.event = '移除黑名單'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = customerInfo.customerId
        recordInfo.note = customerInfo.callNumber
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data.message,
        }
      })
      .catch((err) => {
        console.log(err)
        return {
          success: false,
          message: err.data.error.message,
        }
      })
  }

  //服務相關
  customer.prototype.clearService = async (customerInfo) => {
    return await API.delete('customer/service', { data: customerInfo })
    // TODO firebase還沒有這個event但之後應該還是要先記錄 暫時先註解
    // .then((data) => {
    //   if (!data.success) throw new RangeError(data.error)
    //   let recordInfo = {}
    //   recordInfo.type = '乘客資料'
    //   recordInfo.event = '移除服務'
    //   recordInfo.code = Cookies.get('GladTeamCode')
    //   recordInfo.id = customerInfo.customerId
    //   recordInfo.note = JSON.stringify(customerInfo)
    //   recordInfo.user_name = Cookies.get('GladName')
    //   recordInfo.user_id = ''
    //   record.postRecord(recordInfo)
    //   return {
    //     success: true,
    //     message: data.message,
    //   }
    // })
    // .catch((err) => {
    //   console.log(err)
    //   return {
    //     success: false,
    //     message: err.data.error.message,
    //   }
    // })
  }

  return customer
})()
export default Customer



// WEBPACK FOOTER //
// ./src/assets/js/libs/Customer.js